import PropTypes from 'prop-types';
import FJPhotoRemoveBgCustomLeft from '../view/FJPhotoRemoveBgCustomLeft';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJPhotoRemoveBgCustomLeftContainer = props => {
    useLocalStore();
    const { isShow } = props;
    const dispatch = useDispatch();

    const isNotImage = useSelector(state => state.photoBgRemover.customEditBgImageData === null);
    const isPhotoRemoveBg = useSelector(state => state.brushEditCommon.isPhotoRemoveBg);
    const freeNumCreation = useSelector(state => state.photoBgRemover.backgroundRemoveFreeNum);
    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);

    const uploadCustomBgImage = file => {
        dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(file));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJPhotoRemoveBgCustomLeft
            isShow={isShow}
            uploadCustomBgImage={uploadCustomBgImage}
            isNotImage={isNotImage}
            isPhotoRemoveBg={isPhotoRemoveBg}
            freeNumCreation={freeNumCreation}
            brushEditStatus={brushEditStatus}
            openMediaLibrary={_openMediaLibrary}
        />
    );
};

FJPhotoRemoveBgCustomLeftContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJPhotoRemoveBgCustomLeftContainer;
